import React from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';

import { Button, Loader, Popconfirm } from '@smartplatform/ui';

const UPDATE_INTERVAL = 1000;

@inject('store') @observer
export default class Updates extends React.Component {
	
	@observable updates = null;
	
	updateTimer = null;
	
	componentDidMount() {
		this.update();
	}
	
	componentWillUnmount() {
		clearTimeout(this.updateTimer);
	}
	
	update = async () => {
		const { session } = this.props.store;
		if (session) {
			const { res: updates, error } = await session.checkIfEpzQuestionsUpdated();
			if (!error) {
				const { deletedSessionQuestions, newEpzQuestions } = updates;
				// const mustUpdate = deletedSessionQuestions.length + newEpzQuestions.length > 0;
				const mustUpdate = newEpzQuestions.length > 0;
				this.updates = mustUpdate ? updates : null;
			}
			else {
				console.error(error);
			}
		}
		this.updateTimer = setTimeout(this.update, UPDATE_INTERVAL);
	};
	
	updateSession = async () => {
		await this.props.store.updateSession(this.updates);
	};
	
	render() {
		return <div className="session-updates">
			{this.updates ? <>
					Есть обновления:{' '}
					{this.updates.newEpzQuestions.length > 0 && <span>Новых вопросов: <strong>{this.updates.newEpzQuestions.length}</strong>. </span>}
					{/*{this.updates.deletedSessionQuestions.length > 0 && <span>Удалено вопросов: <strong>{this.updates.deletedSessionQuestions.length}</strong>. </span>}*/}
					<Button className="btn-primary btn-sm" onClick={this.updateSession}>Обновить</Button>
				</>
				:
				'Обновлений нет'
			}
		</div>
	}
}

